import React from "react";

const services = [

  {
    icon: "💍",
    title: "Wedding Photography",
    desc: "Capturing every beautiful moment of your wedding with creativity and emotions."
  },

  {
    icon: "🎬",
    title: "Cinematic Videography",
    desc: "Premium cinematic wedding films that tell your complete story."
  },

  {
    icon: "📸",
    title: "Pre-Wedding Shoot",
    desc: "Creative outdoor and destination pre-wedding photography."
  },

  {
    icon: "👨‍👩‍👧",
    title: "Family Photography",
    desc: "Beautiful memories with your loved ones captured forever."
  },

  {
    icon: "🏢",
    title: "Corporate Photography",
    desc: "Professional photography for corporate events and celebrations."
  },

  {
    icon: "🎉",
    title: "Event Photography",
    desc: "Complete coverage of parties, celebrations and special events."
  }

];



const moments = [

  {
    title: "Wedding Moments",
    image: "/assets/img/banner/wedding.jpg"
  },

  {
    title: "Pre Wedding",
    image: "/assets/img/banner/prewedding.webp"
  },

  {
    title: "Event Coverage",
    image: "/assets/img/banner/Event.avif"
  },

  {
    title: "Candid Photography",
    image: "/assets/img/banner/candid.jpg"
  }

];

const gallery = [

  "/assets/img/banner/p1.webp",
  "/assets/img/banner/p2.jpeg",
  "/assets/img/banner/p3.avif",
  "/assets/img/banner/p4.jpg",
  "/assets/img/banner/p5.webp",
  "/assets/img/banner/p6.jpeg"

];

const features = [

  "Professional Photographers",

  "Creative Photography Style",

  "High Quality Equipment",

  "Cinematic Storytelling",

  "Quick Delivery",

  "Complete Event Coverage"

];

const Photography = () => {
  return (
    <>
      {/* Breadcrumb Section Start */}
      <div className="breadcumb-section">
        <div className="breadcumb-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="breadcumb-content">
                  <h1 className="breadcumb-title">Photography</h1>

                  <ul className="breadcumb-menu">
                    <li>
                      <a href="/">Home</a>
                    </li>
                    <li className="text-white">/</li>
                    <li className="active">Photography</li>
                  </ul>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div className="photography-page">

        <section className="photo-about">


          <div className="photo-about-image">


            <img
              src="/assets/img/banner/photography.jpg"
              alt="photography"
            />

          </div>
          <div className="photo-about-text">

            <h2>
              Stories Captured
              Through Our Lens

            </h2>
            <p>
              We capture the emotions, happiness and
              special moments of your celebrations with
              artistic photography and cinematic style.
            </p>
            <p>
              From weddings to corporate events, our team
              creates memories that you can cherish forever.
            </p>
          </div>
        </section>
        {/* Services */}

        <section className="photo-services">

          <h2>
            Our Photography Services
          </h2>


          <div className="photo-service-grid">

            {
              services.map((item, index) => (


                <div className="photo-card" key={index}>


                  <div className="photo-icon">

                    {item.icon}

                  </div>


                  <h3 className="title">
                    {item.title}
                  </h3>
                  <p>
                    {item.desc}
                  </p>
                </div>
              ))
            }
          </div>
        </section>

        {/* Photography Types */}
        <section className="photo-types">
          <h2>
            Our Photography Styles
          </h2>
          <div className="photo-type-grid">
            {
              moments.map((item, index) => (

                <div className="photo-type-card" key={index}>
                  <img
                    src={item.image}
                    alt={item.title}
                  />
                  <div>
                    <h3 className="title">
                      {item.title}
                    </h3>
                  </div>
                </div>
              ))
            }
          </div>
        </section>

        {/* Gallery */}
        <section className="photo-gallery">
          <h2>
            Our Latest Work
          </h2>
          <div className="gallery-grid">
            {
              gallery.map((item, index) => (

                <img
                  key={index}
                  src={item}
                  alt="gallery"
                />


              ))
            }

          </div>
        </section>
      </div>
    </>
  );
};

export default Photography;
